import { render, staticRenderFns } from "./OrdenDetalleAdmin.vue?vue&type=template&id=acd90634&scoped=true&"
import script from "./OrdenDetalleAdmin.vue?vue&type=script&lang=js&"
export * from "./OrdenDetalleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./OrdenDetalleAdmin.vue?vue&type=style&index=0&id=acd90634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd90634",
  null
  
)

export default component.exports